export const environment = {
  production: true,
  apiBaseUrl: 'https://api.arrivae.com',
  uiBaseUrl: 'http://delta.arrivae.com',
  pptUrl: 'prod',
  uihrefUrl:'https://delta.arrivae.com'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts